(ns dashboard.entity.analysis.document-picker
  (:require ["react" :as react]
            [dashboard.utils :as utils]
            [io.repliance.ui.util :refer [is-descendant-of?]]))

(defn document-picker
  [document-id loading-documents documents on-pick-document-id editable?]
  (let [[dropdown-ref set-dropdown-ref] (react/useState nil)
        [show-options set-show-options] (react/useState false)
        documents-by-id (into {} (map (juxt :id identity)) documents)
        [search set-search] (react/useState nil)
        search-results (filter
                        (fn [document]
                          (or (not search)
                              (utils/str-includes-icase? (:filename document)
                                                         search)))
                        documents)]
    (react/useEffect
     (fn []
       (let [click-handler
             (fn [e]
               (when-not (is-descendant-of? (.-target e) dropdown-ref)
                 (set-show-options false)))]
         (js/document.addEventListener "click" click-handler)
         (fn []
           (js/document.removeEventListener "click" click-handler))))
     (array dropdown-ref))
    [:<>
     (when (get-in documents-by-id [document-id :is-obsolete])
       [:div.notification.is-warning.my-0.py-1
        [:h6.title.is-6
         [:i.icon.fas.fa-triangle-exclamation.mr-2]
         "Document is Obsolete"]])
     [:div.field-body
     [:div.field.has-addons
      [:div.control.is-expanded
       [:div.is-flex.is-align-items-center
        {:title "Select a document uploaded to Repliance"
         :style {:height "2.5em"
                 :border-radius "4px"
                 :border-style "solid"
                 :border-width "1px"
                 :border-color "rgb(219, 219, 219)"}
         :tab-index 0
         :on-click (fn [e]
                     (.stopPropagation e)
                     (set-show-options (not show-options)))
         :on-key-down (fn [e]
                        (when (#{" " "Enter"} (.-key e))
                          (set-show-options (not show-options))))}
        (if document-id
          [:span.ml-2 (:filename (get documents-by-id document-id))]
          (when editable?
            [:input.input
             {:placeholder "Select a document uploaded to Repliance"
              :type "search"
              :on-change #(set-search (.. % -target -value))
              :on-key-down #(when (#{" " "Enter"} (.-key %))
                              (when-let [id (:id (first search-results))]
                                (on-pick-document-id id)
                                (set-search nil)))}]))]]
      (when editable?
        [:div.dropdown.is-right
         {:class (when show-options
                   "is-active")
          :ref set-dropdown-ref}
         [:div.dropdown-trigger
          [:button.button
           {:aria-haspopup "true"
            :aria-controls "dropdown-menu"
            :class (if loading-documents
                     ["is-loading"]
                     [])
            :on-click (fn [_] (set-show-options (not show-options)))}
           [:span.icon.is-small>i.fas.fa-angle-down
            {:aria-hidden "true"}]]]
         [:div.dropdown-menu {:role "menu"}
          [:div.dropdown-content
           {:style {:max-height "15em"
                    :overflow "auto"
                    :z-index 1000}}
           (for [{:keys [filename id
                         is-obsolete]} (into [{:id "clear-selection"}]
                                             search-results)]
             [:a.dropdown-item
              {:key id
               :tab-index 0
               :on-click (fn [_]
                           (when-not (= id document-id)
                             ;; When "clear-selection" is selected, turn the document-id,
                             ;; if any, to nil
                             (on-pick-document-id
                              (when (not= "clear-selection" id) id))
                             (set-show-options false)))
               :on-key-down (fn [e]
                              (let [key-down (.-key e)]
                                (when (#{" " "Enter"} key-down)
                                  ;; When "clear-selection" is selected, turn the document-id,
                                  ;; if any, to nil
                                  (on-pick-document-id
                                   (when (not= "clear-selection" id) id))
                                  (set-show-options false))))}
              (if (= "clear-selection" id)
                [:b "Clear selection"]
                [:div.columns.is-vcentered
                 [:div.column
                  [:span
                   filename
                   (when is-obsolete
                     " - Obsolete")]]])])]]])]]]))
